



























import ReEnableCache from "@/components/analytics/ReEnableCache.vue";
import { Settings, Features } from "@/types/settings";
import url from "@/mixins/analytics/url";
import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({ components: { ReEnableCache } })
export default class OverviewIssues extends Mixins(url) {
  @Getter("settings/activeCacheSettings") settings!: Settings;
  @Getter("settings/activeCacheFeatures") features!: Features;
}
